import React, { ReactNode } from "react";
import { Switch, Route, Link } from "react-router-dom";
import { LayoutRoot } from "./Layout";
import { DownloadApp } from "./Pages/DownloadApp";
import { TicketSharing } from "./Pages/TicketSharing";
import { TicketReceiving } from "./Pages/TicketReceiving";
import { LayoutWithFooter } from "./Layout/LayoutWithFooter";
import { LayoutWithHeader } from "./Layout/LayoutWithHeader";
import { SignIn } from "./Pages/SignIn";
import { SignUp } from "./Pages/Signup";
import { PrivateRoute } from "./PrivateRoute";
import { HowItWorksModal } from "./HowItWorksModal";
import Skeleton from "./Skeleton";
import { ConnectedFullscreenLoader } from "./Ui/ConnectedFullscreenLoader";
import { StatusPage } from "./Pages/StatusPages";
import { NotFound } from "./Pages/NotFound";

const EmptyLayoutComponent = ({ children }: { children: ReactNode }) => (
  <React.Fragment>{children}</React.Fragment>
);

const renderComponentWithLayout = (
  ChildComponent,
  env,
  LayoutComponent?
) => {
  const Layout = LayoutComponent || EmptyLayoutComponent;
  return () => (
    <Layout>
      <ChildComponent env={env}/>
    </Layout>
  );
};

export default (env) => {
  return (
    <LayoutRoot>
      <Switch>
        <Route path="/loader" exact component={Skeleton} />
        <Route
          exact
          path="/login"
          component={renderComponentWithLayout(SignIn, env, LayoutWithHeader)}
        />
        <Route
          exact
          path="/signup"
          component={renderComponentWithLayout(SignUp, env, LayoutWithHeader)}
        />
        <Route
          exact
          path="/download"
          component={renderComponentWithLayout(DownloadApp, env, LayoutWithHeader)}
        />
        <PrivateRoute
          exact
          path="/sharing/:ticketGroupId/:ticketId"
          component={renderComponentWithLayout(TicketSharing, env, LayoutWithFooter)}
        />
        <PrivateRoute
          exact
          path="/sharing/:ticketGroupId"
          component={renderComponentWithLayout(TicketSharing, env, LayoutWithFooter)}
        />
        <Route
          exact
          path="/receiving/:ticketGroupId/:ticketId"
          component={renderComponentWithLayout(
            TicketReceiving,
            env,
            LayoutWithHeader
          )}
        />
        <Route
          exact
          path="/receiving/:ticketGroupId"
          component={renderComponentWithLayout(
            TicketReceiving,
            env,
            LayoutWithHeader
          )}
        />
        <Route
          path="/status"
          component={renderComponentWithLayout(StatusPage, env, LayoutWithHeader)}
        />
        <Route
          path="*"
          component={renderComponentWithLayout(NotFound, env, LayoutWithHeader)}
        />
      </Switch>
      <HowItWorksModal />
      <ConnectedFullscreenLoader />
    </LayoutRoot>
  );
};
